import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalWrapperComponent } from '@myapp/features/widgets';
import { SharedUICheckboxComponent, SharedUiTextareaComponent, SharedUiTextInputComponent } from '@myapp/modules/forms/components';
import { BaseEditorComponent } from '../../base-editor/base-editor.component';
import { CompanyForm } from './company.form';

@Component({
  selector: 'app-companies-editor',
  templateUrl: './companies-editor.component.html',
  styleUrls: ['./companies-editor.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule, SharedUiTextInputComponent, SharedUiTextareaComponent, SharedUICheckboxComponent]
})
export class CompaniesEditorComponent extends BaseEditorComponent {
  @Input() form?: CompanyForm;

  ngOnInit() {
    super.ngOnInit();
  }
}
